import { call, put, takeEvery } from "redux-saga/effects";
import { userConstants } from "../constants";
import {
  authenticateUser,
  changePassword,
  getAllDownloads,
  registerUser,
  resetPassword
} from "../api";
import { history } from "../helpers/history";

export default function* rootSaga() {
  console.log("rootSaga reporting for duty");
  yield [
    yield takeEvery(userConstants.CHANGE_PASSWORD_REQUEST, watchChangePassword),
    yield takeEvery(userConstants.LOGIN_REQUEST, watchAuthTasks),
    yield takeEvery(userConstants.GETALL_REQUEST, watchLoadDownloads),
    yield takeEvery(userConstants.REGISTER_REQUEST, watchRegistrationTasks),
    yield takeEvery(userConstants.RESET_PASSWORD_REQUEST, watchResetPassword)
  ];
}

function* watchAuthTasks(action) {
  console.log(
    "In watchAuthTasks received the action: " + JSON.stringify(action)
  );
  const { payload } = action;
  const { response, error } = yield call(authenticateUser, payload);
  if (response) {
    console.log(response);
    yield put({ type: userConstants.LOGIN_SUCCESS, payload: response });
    history.push("/");
  } else if (error) {
    console.log("Saga error: " + error);
    yield put({
      type: userConstants.LOGIN_FAILURE,
      payload: {
        status: error.response.status,
        errorMessage: error.response.data
      }
    });
  }
}

function* watchChangePassword(action) {
  console.log(
    "In watchChangePassword received the action: " + JSON.stringify(action)
  );
  const { payload } = action;
  const { response, error } = yield call(changePassword, payload);
  console.log(response);
  if (response) {
    yield put({
      type: userConstants.CHANGE_PASSWORD_SUCCESS,
      payload: {
        response
      }
    });
    history.push("/login");
  } else {
    yield put({
      type: userConstants.CHANGE_PASSWORD_FAILURE,
      payload: {
        response,
        error
      }
    });
  }
}

function* watchResetPassword(action) {
  console.log(
    "In watchResetPassword received the action: " + JSON.stringify(action)
  );
  const { payload } = action;
  const { response, error } = yield call(resetPassword, payload);
  if (response) {
    console.log("In watchResetPassword: " + response);
    yield put({
      type: userConstants.RESET_PASSWORD_SUCCESS,
      payload: response
    });
    history.push("/login");
  } else if (error) {
    console.log("Saga error: " + error);
    // In this case we don't tell them that there was an error; they simply won't get the reset link
    yield put({
      type: userConstants.RESET_PASSWORD_SUCCESS,
      payload: {
        status: error.response.status,
        errorMessage: error.response.data
      }
    });
  }
}

function* watchLoadDownloads(action) {
  console.log(
    "In watchLoadDownloads received the action: " + JSON.stringify(action)
  );
  const { response, error } = yield call(getAllDownloads);
  if (response) {
    console.log(response);
    yield put({ type: userConstants.GETALL_SUCCESS, payload: response });
  } else {
    console.log("Saga error: " + error.response.status);
    yield put({
      type: userConstants.GETALL_FAILURE,
      payload: {
        status: error.response.status,
        errorMessage: error.response.data
      }
    });
  }
}

function* watchRegistrationTasks(action) {
  console.log("Received the action: " + action);
  const object = yield call(registerUser, action.payload.formData);
  const { response, error } = object;
  console.log("Result: " + response);
  if (response) {
    yield put({ type: userConstants.REGISTER_SUCCESS, payload: response.data });
    history.push("/login");
  } else {
    console.log("Error: " + error);
    yield put({
      type: userConstants.REGISTER_FAILURE,
      payload: {
        status: error.response.status,
        errorMessage: error.response.data
      }
    });
  }
}
